/**
 * Pure helpers for application list skeleton vs empty state.
 * Keeps loading rules decoupled from page components and React Query hooks.
 */

export interface ApplicationListLoadingInput {
  /** Query or panel is allowed to load data */
  enabled: boolean;
  /** Rows that would be rendered after filters */
  rowCount: number;
  isPending: boolean;
  isFetching: boolean;
  /** Extra sources still resolving (e.g. company cache while position list is empty) */
  additionalFetching?: boolean;
}

/** Show skeleton instead of "No applications found" while data may still arrive. */
export function shouldShowApplicationsListLoading(input: ApplicationListLoadingInput): boolean {
  if (!input.enabled || input.rowCount > 0) return false;
  return (
    input.isPending
    || input.isFetching
    || input.additionalFetching === true
  );
}
